<app-test-screen [questions]="questions" [testTitle]="testTitle" [durationMinutes]="durationMinutes" [testId]="testId"
    [attemptId]="attemptId" [resumeData]="resumeData">
</app-test-screen>